import gql from 'graphql-tag';

export const dashboardAppInfo = gql`
  query ($applicationId: Int) {
    dashboardAppInfo(applicationId: $applicationId) {
      advertisementView
	    attendanceCount
	    couponRedemption
	    votingAnswer
	    pollingAnswer
	    tracking
	    apiLogs
	    sdkLogs
    }
  }
`
